import { makeStyles, type Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
	paper: {
		padding: theme.spacing(1, 2),
		'& h3': {
			color: '#394A61',
			fontSize: 18,
		},
		'& div': {
			width: '100%',
			display: 'flex',
			alignItemst: 'center',
			justifyContent: 'space-between',
			paddingTop: theme.spacing(1),
			'& p': {
				color: '#394A61',
			},
		},
	},
}));

export default useStyles;
